export default defineComponent({
  props: {
    loading: {
      type: Boolean,
      required: false
    }
  },
  setup: function setup() {}
});